import React, { useEffect } from 'react';
import { RootState } from '../../core/data/redux/store';
import { useSelector } from 'react-redux';
import Aos from 'aos';
import { Link } from 'react-router-dom';
import { all_routes } from "../router/all_routes";

const UserAgreement = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  const { systemSettings } = useSelector((state: RootState) => ({
    systemSettings: state.auth.systemSettings,
  }));

    const routes = all_routes;
  
  return (
    <>
      <section className="container   aggrement-page section  py-3"  >
        <div className=" section-heading mb-2" data-aos="fade-down" >
          <h1 >Fairental User Agreement</h1>
        </div>

        <div className=" ">
          <section className='aggrement-section'>
            <h2>Effective Date & Last Updated</h2>
            <p>
              Effective Date: 01-02-2025 <br />
              Last Updated: 01-07-2025
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>1. Eligibility</h2>
            <p>
              You must be at least 21 years old and hold a valid driver&#39;
              license to book a vehicle through Fairental. By using the
              Platform, you confirm that all information you provide is accurate
              and truthful.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>2. Account Registration</h2>
            <p>
              To access certain features, you must register and maintain an
              account. You are responsible for safeguarding your account
              credentials. You agree not to share your login details and to
              notify us immediately of any unauthorized access.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>3. Rental Terms</h2>
            <ul>
              <li>
                Comply with all local traffic laws and vehicle use guidelines
              </li>
              <li>
                Return the vehicle on time and in the condition it was rented
              </li>
              <li>
                Pay any applicable fees, including rental, insurance, tolls,
                late returns, fuel, and damage
              </li>
              <li>Vehicles may be subject to inspection upon return</li>
            </ul>
          </section>

          <section className='aggrement-section'>
            <h2>4. Payments and Fees</h2>
            <p>
              You authorize Fairental to charge your payment method for all
              costs incurred. All transactions are subject to our Pricing Policy
              and any third-party payment processor’s terms.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>5. Cancellations and Refunds</h2>
            <p>
              Cancellation policies may vary per booking. Review cancellation
              terms before confirming. Refunds will be processed based on those
              terms.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>6. Vehicle Use Restrictions</h2>
            <ul>
              <li>No illegal activities or races</li>
              <li>No subletting or re-renting</li>
              <li>No driving under the influence</li>
              <li>No unauthorized cross-border travel</li>
            </ul>
          </section >

          <section className='aggrement-section'>
            <h2>7. Insurance and Liability</h2>
            <p>
              Insurance coverage details are provided during booking. You are
              financially responsible for damage, theft, or loss not covered by
              insurance or caused by policy violations.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>8. Privacy</h2>
            <p>
              We value your privacy. Please review our{' '}  <Link to={routes.privacyPolicy}  > Privacy Policy </Link>
               for how we handle your data.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>9. Text Messaging & Notifications</h2>
            <p>
              By registering with Fairental or using our services, you consent
              to receive communications from us through SMS, email, voice calls,
              and live chat. These may include:
            </p>
            <ul>
              <li>Booking confirmations and updates</li>
              <li>Vehicle availability and status</li>
              <li>Service and maintenance alerts</li>
              <li>Payment and billing messages</li>
              <li>Promotional offers and updates</li>
              <li>Policy changes</li>
              <li>Support communications</li>
            </ul>
            <p>
              Message and data rates may apply. To opt out, reply STOP to SMS,
              unsubscribe from emails, or request removal via chat/support.
              Essential updates may still be sent. Contact{' '}
              <a href={`mailto:${systemSettings?.contact_email}`}>{systemSettings?.contact_email}</a>{' '}
              to manage preferences.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>10. Termination</h2>
            <p>
              We may suspend or terminate your account for violations of this
              Agreement or other reasons at our discretion.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>11. Dispute Resolution</h2>
            <p>
              Any dispute will be resolved through binding arbitration or small
              claims court in accordance with the laws of [Your Jurisdiction].
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>12. Changes to the Agreement</h2>
            <p>
              We may revise this Agreement at any time. Continued use of the
              Platform signifies acceptance of updated terms.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>13. Contact Us</h2>
            <p>
              Questions? Reach us at{' '}
              <Link to={`tell:${systemSettings?.contact_phone}`}>
                {systemSettings?.contact_phone} 
              </Link> or call {systemSettings?.contact_phone}.
            </p>
          </section>

          <section className='aggrement-section'>
            <h2>Consent</h2>
            <p>
              By using Fairental, you agree to the terms outlined in this User
              Agreement.
            </p>
          </section>
        </div>
      </section>
    </>
  );
};

export default UserAgreement;
